export const GENERAL_SLIDE_SEARCH = () => ['data.button', 'data.title', 'data.perex']
export const POST_SLIDE_SEARCH = () => ['data.button', 'data.title', 'data.perex']
export const EDITOR_SEARCH = () => ['data.value']
export const HEADING_SEARCH = () => ['data.value']
